<template>
  <div class="mine page ">


    <van-nav-bar :title="$t('成员中心')" class="nav-bar" v-if="false">
      <template #right>
        <van-icon name="setting-o" @click="showSetting()" color="#fff"/>
      </template>
    </van-nav-bar>
    <div class="wrapper user">
      <van-pull-refresh v-model="isLoading" :pulling-text="$t('msg.下拉即可刷新')" :loosing-text="$t('msg.释放即可刷新')" :loading-text="$t('msg.加载中')" @refresh="onRefresh">
<!--        <div class="header" style="background: none;padding-top: 10px">
          <div class="user-wrapper" @click="doLogin()">
            <van-image round class="user_img"
                       :src="this.userInfo.header_img?this.userInfo.header_img:this.$store.getters.getBaseInfo.default_avatar">
              <template v-slot:loading>
                <van-loading type="spinner"/>
              </template>
            </van-image>
            <div class="login-content">
              <p class="login-btn2">ID：{{ this.userInfo.id }}</p>
              <p style="width: 100%;" class="login-btn2">{{ $t("账户") }}：{{ this.userInfo.username }}</p>
            </div>
          </div>
        </div>

        <div class="box1">
          <div class="userBalance" >
            <div>
              <div class="u-flex">
                <div>{{ $t("withdraw.balance") }}</div>
                <div class="eyeIcon" @click="eye = !eye">
                  <img v-if="eye" alt="" class="icon"
                       src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAASKSURBVHgB7VhbbttGFL3Dh+p8mTuIdlBlBaK/C7SSggKt7SAS4EfzFXkFpldQ5SutY0A0EDv9qaUW6HfoFUReQZUd0F9FJJLTe/nSUJ6hHgmQBPABBHFG984c3tfcEcA97vF5weAT4Ozin4eB/sHSIrCyOfPD7U2n0/HhI7EWwX6/b4XfbP4QcdZgHGycshSiPmfgcc6Hh7utc1gDKxEkYkHFeg4cuiWkpOAAY8bAZRC5ezuP3y+rtzTB04vBc7SWoyBGrhyn3xlqMlkiyoE7y1p0IcHYnRXrV86hXdiIoUUA3GAC5886zbFMF1+KSNY1gC7qVwv6qGtO/aNFcVpK8GX/TdU0N97iYtUiMd7d32n9BSvg7PLqKSo7IlGypsYiu8zlGqxADtEzJ/BoVXKEve3WuY66tEY2h9apRlzzzi7+fKjSY8uSi4C3183EeaTxnBMlS6K7H8ncbcgWMMyNQcFyHLYOn7Q8UCDJ7s06BxbrYAiMjcnttSq+DnaaL04v/x6xKPQSeagGpjXAx6152TsWfHUxOIYkW2OUWS4mZlrH+NgGeca6GGOOKsYoLnnEXGGqt7/bPFISJNei9f4VfnX2d5onssUVMQoSkqWJMG8QrnH7YLt1nY0LSUIbCkNvRXIeJAlAn1E2mSUCWVu2VrqHl8tHzBF/z2MQY6LOo7CaCz6otEEBJHcskPPRAs39J01PlEndR2StNMYoFI5k6wU6dIwQ3kESJvbp5VU9s6I2Yx42smesde7e4++kLun3BxaHWdGONKyJc+QIVFa4pjeEqbbKis9+jgu9O+PCcj3RxbVcQOdDUCCo8Ho+YDA63FaXnoPt78kKXjq0ggebdZUsZ9HN7HkWOvJCPQ1vQbUQsKow8GAx8njkoaA7D2bmyYk10ion+AUhJ4hnZF5UGdNLjh4+FoY1WAw719ULusV1eWCVEsRebZw9oxuVGxsTRnGVvUyccSrZs9fYIAgvYfx3ew1KgkxMqNEdgphxYmK0VQd4p9Mkcm6+cMSGvydECiDi+KKz8xYrg+roo7oqVgbgQd6M5HWQMu7V64EHiUsszjUXJGdjrDSFk7ACjbR1sjRgLupSl+2lIjU8I22B3FjbqDigAJ5efVH2YPfHbJ1ikqAVHWFox8eQBGTFqQZbYlhA4spu+rHnyNmquprukcuTrPh7gWBat3ozxuDI3Eeg4pqSdEEOcmfcP6rIxWsL5zCd/fOy0n4Q3UVnsp2NF/WCdLqEBtiRBnHc4vXzvR6Al8YrqMhRaAhTHnYyi9utfMMKvCu05wy61MfBJ8CdhrUkDJR3kpdvBlUzgrdzl52eMfVP1r2QC/1jdxlypQRVJFe9NmZIaiJemoot2gi7poaK3EKChNTdd6+ddA9m0It07v3yU+tGpvvbH1ff6iEWYMlFn5ILL1FHZXG6FMEMsmujANpkJIyJTBUUl3xq0cq6oLUIEsjlRgRPUamtIFoGnyxuTODFIqutTVAEWZT+PMJCWish62MoDBnjQzrDVyH20QRFUJwGxqwp4Br44QR81V8i97jH14T/AcHBJL9dhA0JAAAAAElFTkSuQmCC"
                  />
                  <img v-if="!eye" class="icon"
                       src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAR8SURBVHgB7ZhNbttGFMff8EN1V+aq2/AGcU4geR2gjRQUaG0HEQE5blZ1TmD2BHVXbm0DktHIySaSEiBr0yeIfYIoJwi9SiJLnLxHUuSY5IzIxAi8yB8gwCGHM7+Z9+bNGwJ8VzUd9l/fEssMbpAO+sMd4OBygLF56d9xHMfX4IZoDkf3OGv2rPbTMt0bcI369/ngthaARffmp4tzmoEy34lwEBG6nfW776Lba9Lh08FDDqwnPiNTYQ9nnPPR1kbrCErCba43/0qL16T9/vBPxmFX9p5gGYMeg6DXWb//rgxc9KgagIu3Y+PSX82ar9sdWrMa/M052PGjFbysIlAO3NUYsxfBRY8XqNvtYscWddxOP+LtjsRkmUERZB1X4rYAnpcELnql0F73mW2aSyc4anv+jDMYa0u1Rud+5MRldXg8eIgfuzlQBRxJqwKH2jUncKcqHKmz1jrCtnpQAS6qUhIuQLNulTCrTLIFQS50+cPy7UdrrdOi7wrjoGEuDavAUSfT2nIdw4wd9c3HxuTidL6QVKt1ZlpvWAD2wdOht7nRXM22zRaNVAUXgpnWDt62oXjFYlgBgtwugqOVPzXhvfDJLkI+kQKSaXH23hY1lpXER9UqaC87IVzjDdHcVxYJdSgUvYpwHl678XVWBo4UP/OSagFzxfcJ4P7xq7rYIfux1gaJEG5HqOvjDKyS/5B5QhMxGJWBm2uqgwORK5Aa+8eDeg6QBbN783uMdT1ZKCG/4ZAG7UDj25sPmt68XGb7yurx780xCCEIZ/FeDhCirSmqoPORrLFpjdeFzs+21tIF9CVwc3EWnKf3qSWLA/Xl7AJkDQGzhYJXBo5Mdth/cQtUYmayOHHPt9SAFaWE+x+TjIB5nGtj0bfKKgHEPTLJThjTpaOlICwUVxbmcwwSf2JaPlYm7/jUUgJiQ+MEFtiKrCFjwihGJStOBUdJbFhn/u2Hi1OQAqYLA4Qwlc6gposLoy3zGcdp+giST0wzcGROHGhSjyKD7AhAcVWMDMCnL3OAj9Z+ptF5cdFCn+lBWYk+h4kt7qsn5HcQb39xiubKPsfdqwvpQMabD371coDhS013hWIj9K+MVD530B/8Eqf9DbFDVf4Y95HUp7ri+yuA4SwyoXME+S/yo4VwEYwhmtAns6ryx7Dt7GkuU7cwHyQTiaOijKbsGWLv2dDWg6BhTrRR6K8SEZx29RRYLt0ixQegN9JzRIUdokjZE6DKDaRnEpoJM4CTqmcIlYT8cbsMHEm6k9AGjnCVshKVKCZS9izCoc4WHcCkvz7iBZHLhOOklo4EFsXDQOfeH7+1zovaoF8h+gwDMLbDMxk3HeL1CTxxNu4qf48wBZybhSt8F4k6EZNUgrEBCrc2n1I0MQtSyagCR5pqcIS+2c74JoE0QK1wBzIm8I/jtEr9VIq6rwAnKj6INwhM8dfAR9OOGOMj2sNVYWch4Nckm+HpzEgTXq6BP5uA/9gJM+WvUghIIcWYQanT3LdWGGaWPoKfpFs3CC6nve7Qhu+qps9uinSnH+Kh2AAAAABJRU5ErkJggg==">
                </div>
              </div>
              <div class="num">
                <div v-if="eye">
                  <span><span>{{ formatNumber(userInfo.money * 1) }}</span></span>
                  <span style="font-size: 0.875rem;">
                    <span>
                    {{ this.$store.getters.getBaseInfo.currency }}
                  </span>
                  </span>
                </div>
                <div v-else>
                  *****
                </div>
              </div>
            </div>
          </div>
          <div class="cells2">
            <div class="item" @click="$router.push({path:'/Moneylog'});">
              <img
                  src="data:image/png;base64,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"
                  draggable="false">
              <div style="text-align: center;">{{ $t("变化") }}</div>
            </div>
            <div class="item" @click="$router.push({path:'/Recharge'});">
              <img
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAT1SURBVHgB7ZpdTiNHEICresYIVivFOUGGNwyKmNViFOVlvScIOQEGHyDOCUJOEB7zsLDODbwnwLysVsESjpIYKy/M3sCREnYFdtdW254fj397zMLYnk+ymKbH7e6a6qqargJISEhISFheEO6JzLeFr/BW2kiQJkQLHgEkctoCHGwJ5+ry5P1U34EZsOx8etUUPwiEPA9lQYwgIIcIStjG0jhhRBbARvbghSAsA2IaYowSBGtGsV59/WZYfyQBbD073CYTa30DETR5NIcAagTYRJJNeGh46/GCLF61TQh9D6aFZP/z++kf4a+YEAFpQjkgOYc14eCv6qsKxIit3cI+b4EjUAJhDIIy/1kP36etAZs7B98BinKv6VAKcldvpzM4D83GN3lLtIxL6GmDBJlrXLw+D94jQBfCPe+SqBzXxSsa70oOz/LYbQsQ+fA9+gIQaLuXBOINxBwDqeK3KBfu1xcAgCeARsz2/TCMOwoYPrTC/VoCUHvKayirPwfUaiWeJzluWwVswf6JXkAFO2sG7KMwbGj7T18Zls1sgeAhIWJXiyrA4Y8soxSVaSO+UYzVgI2dw5+emOKaF68MSR4C6v8odIMuGxH2hBAlNMFRc4QZGCmATLZwKRCP4h7pqTmyJl4qTYUIDN0CmZ3DXzDwtPm6wp+yBHEuDaPZePerA4+Alcunn/5n2hx2bkuAIvSCHMZeM4XShB9Bk4FAaMPm4CFlXLttSXTUqJ7+DDFkU6m/0tIeN3ftL52O0Qvdlz28dj0AB25WMHYZ2ALCFPvuNRubSlwXr6jz3JR2um31ZgqaDAgAEXPeNeAxxBz2Bt4ceb450EQMDujvfVqhGsQcafqBDkbwUn0CsJUlDbxGxjnOd+nE+25QxnPX9QZ9Avi4GnyH9qOn2IPkGb61J8YXoEGUd4GFIhEALDmJAGDJWXoBjDkPQKsbQ88DaEFEzM818LyQbIHRXeRIY+UlzAGifXsWVVvHboHHOvjQhW0VRCVxg7DkLIkA0HKvPty0/w32LLwA1Bmn1+Bzg/CZ4cILQJi47V6r2oWBflhwEEXRu4ZgorTLQgtAHZvzU8+5bVrBUvieSBUicQZv0c48z+8BGvwJLJ7o+Ort6cAZ58IJgM8Hy4hG+J+1q+rJ0KyRtgCUVcWUOOMzeCvc15Fy9dT7ocxO4QwDT2EcnyMDpQq3COi4Xj0ZOa62DVCZo2GL7/wgYtE9lt7M5u1pF9+dCBbhHsCupS/xwor/P22v1ycIVVsDpCl/E20jD35i0kNpgOtn6xel2uZuocy+Z2+qcQO1PNoQpt0sp0zBnk4+YyA5Gix6GJVsjBvBOdcvTrQq34ZsAT8hspryg4i48nX24IXXINBO5Q0RAFb8AfWTjQ+NDJTtsT7PLgADZMnvxGLmWX9RUZxQHkliwMao2mVNBgTwZ7eS0uk0VKLUpMrG84N9iBmqWDvkjp169ZV23eJQg7G1e7hN1F8MrSq0iAMKdm2cjZ0tcUoTSthdOtUqvYINtnJp7BVJ8e9b4dolRLL/HlIMPYmRFrNXE6xckwX3DQcoN632+iQPo4qfYELOXwU7rAXfRy3WHhkIqfp6abRfsrSPwN0S98S0forvGyMgUpp4pIKdWSrVp/aZqkrUbJmWlNJisc1kGAWI82km3a329muWOFp6byA271Kp2rwc2CYkJCQkxJlPik3Dy+A6egMAAAAASUVORK5CYII="
                  draggable="false">
              <div style="text-align: center;">{{ $t("存款") }}</div>
            </div>
            <div class="item" @click="doWithdrawal()">
              <img
                  src="data:image/png;base64,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"
                  draggable="false">
              <div style="text-align: center;">{{ $t("提款") }}</div>
            </div>
          </div>
        </div>-->
        <!-- 红色头部背景 -->
        <div class="header-red-bg">
          <!-- Logo -->
          <div class="logo-area">
            <div class="logo-text">
              <img  :src="this.$store.getters.getBaseInfo.ico !==undefined ?this.$store.getters.getBaseInfo.ico:'/img/null.png'">
            </div>
            <div class="logo-slogan">{{ $t("更好的机会。") }}</div>
          </div>

          <!-- 用户信息与右侧快捷入口 -->
          <div>

            <div class="user-info">
              <div class="avatar">
                <img :src="this.userInfo.header_img?this.userInfo.header_img:this.$store.getters.getBaseInfo.default_avatar">
              </div>
              <div>
                <div class="user-name">{{ userInfo.username }}</div>
                <div class="user-balance">{{ formatNumber(userInfo.money * 1) }} {{ this.$store.getters.getBaseInfo.currency }}</div>
              </div>

            </div>

            <!-- 白色操作卡片 -->
            <div class="action-card">
              <button class="btn-action" @click="doWithdrawal()">
                {{ $t("提款") }}
              </button>
              <button class="btn-action" @click="$router.push({path:'/Recharge'});">
                {{ $t("存款") }}
              </button>
            </div>
          </div>

          <!-- 右侧圆形图标菜单 -->
          <div class="quick-actions">
<!--            <a href="#" class="action-item">
              <div class="action-icon"><i class="fa-solid fa-gift"></i></div>
              <span class="action-text">{{ $t("过感恩节") }}</span>
            </a>-->
            <div class="action-item" @click="$router.push({path:'/Notice'});">
              <div class="action-icon">
                <img src="/img/mine/notice.png" class="icon">
              </div>
              <span class="action-text">{{ $t("通知") }}</span>
            </div>
<!--            <a href="#" class="action-item">
              <div class="action-icon"><i class="fa-solid fa-bars"></i></div>
              <span class="action-text">{{ $t("标签") }}</span>
            </a>-->
          </div>
        </div>


        <div class="cells u-flex-col">
          <div class="item"  @click="showSetting()">
            <img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAI3SURBVHgB7ZdBbtNAFIb/Z8dRV+AbkCOYE+AeoALasA8XoHFgUVGjDlJKdnGR2AMrVm3KgjXJDdoTEE6A9609vElAkarWnjdNq7bqv7KSN+NP89689xu41y0TwVFKfQ6Dhw82Ad3RQGv+qz7iLY9QkErfbPyGg5yAdoejTU2F4sfwgpCcNNR2r/0RVw20m+3vaGhlE8tQXSmUCGgw+NYqVoJfgiU5py+SpM+DQOVKsAOZQvhlV7JABKRBzyAWdSTR1kCDbNRipBByhf1PPx7ZBotO6DokKup+tv/H5ZTSpG39HuEJmcYn1lgSLALytKcgFPes95J4EdDb3vqEs7xnv0LvvUtejCGQ0+jgWsr4Zd2ajb9sJ+2XEMrplqXJRsLp6+D8+hhzmlZdYIycp/1/qWwU+jiNPDTyE2Cqkuc57pKcTujD8OCJRhlpoognXESgWW9iXzQlM1DZE5Gm8fwSXCHQPx/U4cfIJn4GyL4o7bW/wlJWQHPb0RhxuBXIuWAFxTY2pBbIwLDt+LmwqW6yhaq99suAMSKzh18e1sVVAvWHB0+XAbMQReZCwBWISDvVTJU06bjq/xvnhyqBtCYXu4HL7FkJdEo04aY3xbJgeK+0t/4drkBmLvllk409LWE+UR74zdqPhNoa2nq9dtwom/FlTsqcTMNvxluv1o7rYq2K2kB58FaNOZOBUc7xqoD32AZmtgJCze1GEXsg7lGmLVBrYfxNavV0NlxRTE4QHN45O3Kvs/oLTyLBMjIorv4AAAAASUVORK5CYII="
                draggable="false">
            <div>{{ $t("mine.my") }}</div>
          </div>
          <div class="item"  @click="$router.push({path:'/userGrade'});">
            <img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAKzSURBVHgB7ZdNchJBFMffaz4sqwTmBpIT6A3C3kVI0HVwb1WAciVYTkqSuNBMOEFg5UJAPIGTE3gE8QRSpbsw/eyOoMPQ3TPSmYWp/KqSGvr19Py7+/V7rwFu+c9AsMR1z51cqXhAwJ05/Dx0m09nYEEWLMkXCzscyJVzy0FRijkECxhYQgju8lkIq4MlVoKOT8fbBFBe/hb7X5ZtYIGVIEJej7ZxDKpgwYpTH3mjV3TlD9CHAN3O89o308tH3vBreIUWzObwY8vk3PIgZEuFj+KxggSNdutxb2mLrNAfH6hThvzu6XBfN+ixsCnESJwsFXb07423c6XCFylG/uYIjbB9RRABTpbP0h/Ev37X++CpBhYD1UGHwiZXpeuNPI7cX/U79LWCGP0VFBq98VpsTfft6P6y5eTkfRkWM9RQcb1zJ9w/W7r3WUy5Ee0o4tdg5WvRDmIW30U3BxSI2bgZjpOAcVfM0ui8YuBJhjM3YFSl30KcdTE4fdmsbYXbVIGxL/4aqo9Ih5+zK6ePRQqeMx4n2o+2rR179balA0LQW29T0PWG8hQ8hBRRbZdEGRgR0l8lRnSmbFc1XgLrQcpQ/q5y0kpBbnNXRlkf0sPvPHukzALa8gMpMyEMKlo7wBQMaKL4wsj6OpNW0CXCQBiV+ywcoNo+ePIJDMgUIaOy0pi/4+ve02Z707axIBNbFXJFIJTIgKnbLom5YiR2Bsgrax8TMxeZfmp8FXhZ2U7MeIKNguaIF1nAmSqVGH1Ez6zT2huYOhgLtMW29eHaiI9vsRXjdaaSaGZXkegaZKoAkotRp4ooiWpq1B3/fwCBJ1rpxBdFEVf2CakMm0Bs1m7tpp6OUiHxCr15N34g6uiN/ehFa+8iSb9EgkLXo42R5W+7WYu9Zie7KAofAEuIcAq33ER+Afdb8b/ZBrqfAAAAAElFTkSuQmCC"
                draggable="false">
            <div>{{ $t("VIP级别") }}</div>
          </div>
          <div class="item" @click="$router.push({path:'/GameRecord'});">
            <img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAIeSURBVHgB7ZhNbtNQEMf/YzdqVihH8A0oJ8CsEZKrFtZlj0QTWICSqo6UNhtUhxNgVmwSPk7QcINwA3ODrqnsYSaJJdf1R0pw2kr+LZJ4Mu/N/728N/NegJp7BmUZT8++Po6IDwhsM2Dhv8IzMI16nf3PWEXQiTc5ZrCLipGBBhSS3Xu79ztpN5IPw+EXqzoxPJK+nxDI1yeZCYtNnrrep1auoKjZOEZFyIz8OGo/n3bbey+3ou2dWFQDD17nCpJGO9gA7948+yVyRouYbCNPEDYkaA7TdPnJTpoN3BIS+CLHfre4c4K2ir5kUBDCeLQNtCJE57IALbUZCPvXfc2H8nqIKgXJ9PlH7V39rS8G3uS7vB8Ss9vtvMjMsife2Fk1s8vA4g10ZS1dydQDb8ypZjOEhmNe/iHJUecaTDOsyXCRIiINUDRD0hdoGZwlGcaCyO9Jboq9Cmdo3sjkIDQbyRFYEcHPCIjSvpK9LJih0XSTXiWC1kdKhZtllzX5UzN32l65ICkV/Zv417tsLUGMyBl8mPjzXQbWYFKC4J6eja/56i7TGcSabHCXrUZdy8qoBZVRCyqjFlRGWWLUsuFLMmxJFj4o8FMfTY3O4qxTgSAtotRo2r1XT+dXXbliB1m3Wj1exBV96H3rx0UY/4iR7nwpZ6RVPhajaND02SYpRnnf3g0upV18Ccw7CxVBN/SP/4xwiOF3O/sfUbNh/gJQzdvPptdfDgAAAABJRU5ErkJggg=="
                draggable="false">
            <div>{{ $t("历史") }}</div>
          </div>
          <div class="item" @click="$router.push({path:'/RechargeRecord'});">
            <img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAJvSURBVHgB7ZZRktJAEIZ7BijRKmvjDXID2RMYT4DA6qt4gjWrD5ZgVbaEXV8k3GDZJ6tcBDyB8QTiDdYTmLd1FabtoQxmQhJIqFCWle+F6c4k+el09zRATjwMMuakN7oHIPSgXwC6IPi0/bzxDXYlqGsPxwjwIGaLWxTcePGs/tVzcMiITm9UDYhxGYh9ikHf59NmXPhtKEY9UIZaMGwyQAM2hg1aZuN4sWJYQfXitGU+mtJz9+i5T31+I1aQZZ1ppb3btgDRlDZCEtDq2u8/yhdDSlY+mRRDIpqQEgFMW/UyN96OEHTSGz7eRkwkpXJlBoWaXL48qn9um407gVwKFyRYBmLkS35e65ZZU6JCuamH7lVNVoEMEExM3rwd3fVsagdnUe2gCBnBkDnIliUhy9vp9oYWhcYIiHH89ykRoi7Zh+1wXpkPHbmQucKAWb4E1pBBf0VM6WYzoEHFsseySkIqZT2UJ5ehfnusJ9n/T6FE6PT0nT4vFw/pS6aKUHKEC3Pe9x+wSlKLcukT/ehJ+3N6KB4FYdBi3/MoSY0LMbtGbTWZnfZpyQWtIxe0jk3OMocq4fKvibIqFpVBRTvBiNmGrtGZFX6ibyPIbZsH94POjv3hO40PTss8qEXd2LXHJHr+BbYTJP8t+ru01uldVEHcWo6knF/rNN5qgqIkR4oZ3oiY/n5UYTPcGEEoX2woLsYmULhamsJzUxOlkYL2X0EYCXq9Mn8rSc2RW7BrkA/8piLozwwzgd2p6beP6ucQJUjyC/gTEjWAjKFPPphB8TjEH85r+8LgwA9l6bKUA1sY1CYcBHHuTZY5Of89vwF0Gcp+urL/oQAAAABJRU5ErkJggg=="
                draggable="false">
            <div>{{ $t("充值历史") }}</div>
          </div>
          <div class="item" @click="$router.push({path:'/WithdrawRecord'});">
            <img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAIzSURBVHgB7ZfNbtNAEMdnXDsJgga/QcwTQJ8A3xEipe05cEdKbTgA8cGIlHJp2krcE05IBLXpgTPhCUjfwFy5NBVIfNWezvZDih3ZrZN4o0r5SZa8q/Hqn5nd/04AZlwxEMZgrbFbJfTL/GqeTXWBoOXYy+9hREYS5LpNXb05vzsgJLIoujVr6RWMQGpBp2JufOFP7yQvPJqoVIIuK2YcUUqaYK2oVy4rRkBAbr3xqQIpSF2y15ttM028D2rPtRb7cFWJzZDYL7ni/IMA0YSJEfS5jl3HXtmDNILebuzc9pWgQwAGZACv66GPpvNs6TtcJGh9/YPhF7Rv/KpDhghRPvxccK3Hof01dMpYTDNrMQLOhKFBsRqdDwkS2YEY980CtoVVSBJE+XwJ5KLX330uxQuio1swZVI59aQhQM95ci900lSQCm3x6dpj9/bEiB3ci0ZIzBC2HGvF8g9/9XJEJfG8aezcHYoaHKxtfHxEitKEDEAIFpQ/fn/I47RrxmDZpJWMtOsHRH8Nvj4SPU5ayfDf7/JL++FXpDnhPV3xcL/UOfr/43AwTl6GELg3ans1e3Gbh9txcTJPmQ6Infpmu8f5Orm/kKBTs5dD4qbgQycdpykeztpWslOjegBTJiRoDnEfJBN16pCgF6fO2QVpYCs6M7SH1CC/er7pskTcY6AVXLhI0POn9/fVIGei+CBDMagVzGi5BIl/g/iuqRBSmRupCXWQ/CO5V3eq8U3+jBnjcgxU9rcX88uSlgAAAABJRU5ErkJggg=="
                draggable="false">
            <div>{{ $t("提款历史") }}</div>
          </div>
          <div class="item" @click="$router.push({path:'/Setbank'});">
            <img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAALlSURBVHgB7ZjNbtNAEMf/4ySlJ8gb1DwB4QlozxxKaXsuuSO1rrhAg+pKScuBJukTNDckaD76BIQnaHgD9w0icUKKvcyWBBl7k2xCXMfIv4vt2bF3Zz07uzNASkpKSso/QJiD02rrmUfuCwKZAshj4YgeBLqlw93raZozGVCuftkkojoP2sQ9wP04BqhxZG2fjNPRNuC0erXnERqIh0bJ2imqGrQNOKu1zQEGJiKB8obIrAl2S35YV2qAbNWfmGsNRImcKBdum28Lgab+AD8e21ax7xcaWDLeWlsOu8tTOeOBpnwOD/eD+mP/gG1f5nOP5AtCzkQBESEgeEapTwId4VGn9Gb7dtRWrl19xd8u1WXjNvzvZ1UfrVTb++yPNn88ghAZ5PccCuKBZkS9Ur06ODrcuZCyDDJFF94NhuNQRb+QC52dfTJ58HVEEt+nw4bUP5y3nsh76U58aYzaSMcAd3VlHzEzMNxXfx4EdSfpKhaxiMzf9aH10V2G6PskTYUBFLsB/uPJTw6fk3RVfyAW3/fj93Xb2prVgGTxXxrQQ8wIkKOrG9rIePPY8uAd8yZmIhbIodyqrasdMmC4eRSREBK/BpRnIbmVc/ISWzh9d/jym65uyIBKrXk8gGcjRngM9qQ00k/IhXjx2ogZHsOBWg4nKFvWNaB0X0qQAWqE0QiKEmPA3ea28qAblGeREAwh6kevn98G5YkwgBf1Blfpuqo2TQNEfYDshV+S4RoRwWjL47fswEXWGfd27m5Reu15jyfvLfXgJVoGlKxdSyF2yrVmg6+FSR2MqJx/PoFhXGLBqDKyUAJRrrb2gjJZdiEIWUkrlD821zC1J2MT+vR1FUN1Ia7F3EBRBwrG4GHalx/XPklXg54sbukoKlxIVgHCif20ivRiK9aknZOEXMgQ1EHczJAPhAyQJ0FFXfLekH2XFPF+vP4YZJV4mJmxO5EZXbVCBg3hSNcV8K51IlpKSkrK8vAL46/oCjTilF8AAAAASUVORK5CYII="
                draggable="false">
            <div>{{ $t("我的银行卡") }}</div>
          </div>
          <div class="item" @click="$router.push({path:'/SetLoginPassword'});" >
            <img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAMOSURBVHgB7VhNTttAFP6enVRZhhPUNyA9Qc26CxIo3WL2XcSomxZXZMFPVamkNwBWlVqgqXqAmhM0PUHDCeotAvv1je1QbAgemxIJiU9ybM+8mfn85vm9zwEecM9AqICtnaOnEbEDRC2ZwpKmZtoVADyStiGYB97q0jeURClCighTtMeApWMvdiOTDefN6sIxNKFNaGPnaBlCJh0mnoAQ4+MQ5nBsUxdPRQgtAzQvt7b0Wwkzw/FWF/Z11tEitL39yQob9Z9y2ZQBe2cw3Z7bCW4c0/9qCbl18ZIDtZUhtbxXiydFa9WggahRX1dkGDTy3MUVnTGv3c5ITisb/QNLzjbMqCtnt2icAQ0IkXZKTYtMZgE2eskVOTr2hVu2+f5zi+uG2q7Ac5/PoAI2+od/5LFku6Mna+6L4U22hR7iWu1xejlEZahUIL9szBZZFhIiPq/klcwc8vrr2mrFUDrtCJVBga5lCULTwcSgTspDqN4uW8ykRCCguDSUByelRR0+gXxi8idl7yuE0iS4mxC5O8jCAw6pm0+WVxKjJMEf0KxVt4F4rQ2TldfmLrdnYmhr52CZp0DmEmwVGphEiAltTBmJjPmHLKHy3vGlos+dw5xRh4zvUMn0IOPty/e5GCIrpqUBWXiw5i52cs0DdWz2D3bTKq8xz4W4u44QN6EBVfVRb6jqLTrpyzyIuvFYRk+pRCVPaojamvNlbColRnkq33v57ESlCCGjvGLHuUquVZCmWmkPFVCV0Eido0emne/jWGfHNpWSaCVCsmjsZqLa73yfvDW/Ehtobf9/ITQWWyr9S3D3kuJJATG6b90lP7YAV0ohmdIxFlJaI8EfPXfpWkm62T8ULc09aEKE3wWPWpYdB/qupq7o5aaI9964Hr378H02NE67QsaBPjLCr3ZNpwV9OFKPHCEWB/A5TkvHTV68ZWOITR/VMJYXpSGydoBJhM4I+3QrZViSjPqsyn1AZgiphGbAmJsGKUWG6g07336TYlxm4nb6OdzCrSFpQV6a5I8Iw1e7UfT1+4B7gb8NMhF/nOqbSQAAAABJRU5ErkJggg=="
                draggable="false">
            <div>{{ $t("登录密码") }}</div>
          </div>
          <div class="item" @click="$router.push({path:'/SetPayPassword'});" >
            <img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAIxSURBVHgB7ZhRbtNAEIb/2ZIqQqKEE5AjwAkwzzxQ2r7jAyCFRrxAI7FIlLw15gSkTzwgSG4APUHLCQg3yDt4hxkMIqTr2F7HFUL9pFVi72j3z87szG6ASy4Aa990tGENEAJRAa3rWz2AYwa6+k4+Z4aRsKPp4MnuVwRQSZCK2Ny6dt8RYnmMCsw/icLxoL93jHULenX04Y6jdFvMY3ms6pq5tKlhM37W3zkpMl4p6PBo0mNKY/l6C2tAXUoMu2rVcgUdjt4/Z7BFAxDIHuzvvvD3eRgO33bTdusLGkRcGPlcaHzGaXuzh4bJYvI8XkFUPXADMN45DP4xagli0EwC/+53bNzQJnERS8DOUIMrCETFUKsdDR7dW8zIx8PR5CSFOxWLILcHr5BhTpbE/OTp/oOZxGCCQIIFOeLPeX3MdIZAggUR0000QHhQZwXW30VuG4HU2WWRlpfll1nJyRfbpCBorXs5ene6IGZSt/7VToyy/Re2N9c+FfxfmboJvII4O+WVYrEQ/+2+Ipx3Dm/pMExTSXyPUY5OFtg0r1QuWle92dy7Qnpw0lMdSkMazFFpaxnbV3ayvhX8OlMH1yXPdHNitgf9vde5FgUjQKp318F9lPzSRQ1yTgfnKNxlWr2/wdyWZR4jGE5SGaNIjFLpopi50NnywVvsolqClLIuLOuiZSonxt8ulN+yItjLu2iZ4D8bFLliP2Ri+2e1+Ay8kQz6O5Xu82vHjiYdbbjkAvgB+ZXUQsD9ep8AAAAASUVORK5CYII="
                draggable="false">
            <div>{{ $t("交易密码") }}</div>
          </div>
          <div class="item" @click="$router.push({path:'/Notice'});" v-if="false">
            <img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAKNSURBVHgB7ZfPjhJBEMa/GgbkYuQRxicQn2Dnbsyy7nqWvRsJGw/GJXFMFvEi6BOIJw+7CsYXwCcQn0D2DSbxJjvTVgPuwkzP9NCB/ZPwuwypmUp/VFVXdQMbbhiU5aM37a9bIQUV/umyi8PPErLhA2LEPkME5DWe757qHLSCmp0vrwSEhxVAIO+wvvs6/ZsUWq3PTlDM/8YKsYTlvjx49CPpvZ3mHBQLNQ55zC5AIwvoIp0qR9aJGmepNxPES5dVVilGF3pOtXx4UTunzUnz0whSE0JUm+0TnyZFG0dMil5Uk98ZCuIFHZFkJ7wXWB72cWAqSAcL63M9+RFbiWunAkOMBUkxh/W9HdU7rp+eqShjQRx6VzbMqD1EUEraDGsVxJRCCgdxM8Gktv6jFcSpGfECozmT3CVZIzDE3E5M2iSZBY2Ru+/Vd2Jbu9XpOSHCJ0kjRY6IMawPKl+v00vd9pmGaxJv332/d2b9HXDNzBYh384V3BfPHv6CIYmCpnPMrvG/rcz3Dpk+C3TeqS9EcbjnxDTbvZqgwMNCIxRD3eRXCjpqH2+DqIv0rtpt1Pf2J+I5hZSz75yL6Zx8ZOHVFF8fQlQbB4+/aQXJHOcR/NR11Klz/DixxHHFP8Ofu159f6HOYkVtC7HFY8FBBuTCR53jColJNMF+nF7hIhslW9ze5uenVEFEorxcH6GynGswgIicqM1SfOfgklCVhYVrxkaQjisVRIszcoJK0AiXhBA0jNrigsJAe5lbGYVbekFjK99H5Fi6HqjbePrgVCtIHhk4t0aNLivyXod80VO9Uxa1nE9yTmE9DClfdFXRkaRfpXmKBwjl7bU8O+05MGB66qQBrLDfqMUn/IYbzT9z6uZK7NpF2gAAAABJRU5ErkJggg=="
                draggable="false">
            <div>{{ $t("消息管理") }}</div>
          </div>

        </div>
      <div class="logout"><van-button class="login-btn1"   type="primary" size="normal" @click="loginout()">{{ $t("注销") }}</van-button></div>


      </van-pull-refresh>
    </div>
  </div>

</template>

<script>
export default {
  data() {
    return {
      eye: 1,
      userInfo: {},
      menu_top: 40,
      isLoading: false,
    };
  },
  methods: {
    refresh() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
        if (localStorage.getItem('token')) {
          this.$toast(this.$t("msg.刷新成功！"));
        } else {
          this.$router.push({path: '/Login'})
        }
      }, 500);
    },
    exit() {
      this.$toast(this.$t("msg.请完成任务单后进入"));
    },
    showSetting() {
      if (localStorage.getItem('token')) {
        this.$router.push({path: '/Setting'})
      } else {
        this.$router.push({path: '/Login'})
      }
    },
    toNotice() {
      if (localStorage.getItem('token')) {
        this.$router.push({path: '/Notice'})
      } else {
        this.$router.push({path: '/Login'})
      }
    },

    loginout(){

      var username = localStorage.getItem('username');
      var password = localStorage.getItem('password');
      var remember = localStorage.getItem('remember');
      localStorage.clear();
      if(remember){
        localStorage.setItem('username',username);
        localStorage.setItem('password',password);
        localStorage.setItem('remember',remember);
      }
      localStorage.setItem('lang',this.lang);
      this.$router.push({path:'/Login'});
    },
    onRefresh() {
      setTimeout(() => {
        this.isLoading = false;
        if (localStorage.getItem('token')) {
          this.getUserInfo();
          this.$toast(this.$t("msg.刷新成功！"));
        } else {
          this.$router.push({path: '/Login'})
        }
      }, 500);
    },
    doLogin() {
      if (localStorage.getItem('token')) {
        this.$router.push({path: '/Infomation'});
      } else {
        this.$router.push({path: '/Login'})
      }
    },
    doPay() {
      this.$toast(this.$t("msg.请联系客服充值"));
      return false;
    },
    doWithdrawal() {
      if (!this.userInfo.paypassword) {
        this.$router.push("SetPayPassword");
        this.$toast(this.$t("setPayPassword.title"));
        return false;
      }

      this.$http({
        method: 'get',
        url: 'user_get_bank',
      }).then(res => {
        if (res.data.is_bank) {
          this.$router.push("withdraw");
        } else {
          this.$router.push("Setbank");
          this.$toast(this.$t("msg.请设置收款卡!"));
        }
      })
    },
    toService() {
      if (this.$store.getters.getBaseInfo.iskefu == 1) {
        this.$router.push("ServiceOnline");
      } else {
        this.$toast(this.$t("msg.功能已禁用!"));
      }
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data;
          this.menu_top = 15;
          if (this.userInfo.status !== 1) {
            this.$toast(this.$t("msg.账号下线"));
            localStorage.clear()
            this.$router.push({path: '/Login'})
          }
        } else if (res.code === 401) {
          this.$toast(this.$t(res.msg));
        }
      })
    },
  },
  created() {

    this.getUserInfo();
  }
};
</script>

<style scoped>
.wrapper{
  margin-bottom: 100PX;
}


::v-deep .van-nav-bar__content {
  height: 100px;
}

::v-deep .van-hairline--bottom::after {
  border-bottom-width: 0px;
}

.mine .header .van-nav-bar .van-icon {
  font-size: 45px;
}

.mine .header .user-wrapper {
  display: flex;
  align-items: center;
  margin: 0px 40px 0px 40px;

}

.mine .user_img {
  height: 130px;
  width: 130px;
}

::v-deep .van-loading__spinner {
  height: 50px;
  width: 50px;
}

::v-deep .van-image__error-icon {
  font-size: 70px;
}

.mine .header .user-wrapper .login-content {
  flex: 1;
  margin-left: 30px;
}

.mine .header .user-wrapper .login-content .login-btn2 {
  display: inline-block;
  font-size: 40px;
  color: #000;
  margin: 0;
}

.mine .header .user-wrapper .login-content .login-label {
  margin-top: -13px;
  font-size: 28px;
  color: hsla(0, 0%, 100%, .6);
}

.mine .page-bg {
  height: 500px;
  background: linear-gradient(270deg, #c24491, #775fd9);
  z-index: 0;
  background-size: cover;
}

.bg-container .bg-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(hsla(0, 0%, 100%, 0), #775fd9)
}

.mine .content {
  position: relative;
  padding: 10px 30px 30px;
  min-height: 500px;
  background-color: #f2f2f5;
}

::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
  color: #ffffff;
  font-size: 35px;
}

.mine .wrapper .content .finance {
  position: absolute;
  display: flex;
  align-items: center;
  top: -55px;
  left: 30px;
  right: 30px;
  height: 120px;
  background-color: #fff;
  border-radius: 15px;
  box-shadow: 0 1.5px 1px 0 #e4e4e7;
}

.mine .wrapper .content .finance .line {
  width: 3px;
  height: 40px;
  background-color: #ccc;
}

.mine .wrapper .content .finance .finance-item {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.mine .wrapper .content .finance .finance-item .text {
  margin-left: 30px;
  font-size: 30px;
  color: #000;
  font-weight: 500;
}

.icon {
  font-size: 16PX;
}

.mine .wrapper .content .menu {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  background-color: #fff;
  border-radius: 15px;
  box-shadow: 0 1.5px 1px 0 #e4e4e7;
}

.mine .wrapper .content .menu .menu-item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 50%;
  height: 130px;
}

.mine .wrapper .content .menu .menu-item .menu-item-label {
  font-size: 30px;
  color: #868686;
  font-weight: 500;
}

.mine .wrapper .content .menu .menu-item .menu-item-icon {
  margin: 25px;
  width: 60px;
  height: 60px;
  -o-object-fit: contain;
  object-fit: contain;
}

.mine .wrapper .content .wallet {
  margin-top: 80px;
  padding: 0 30px;
  background-color: #fff;
  border-radius: 15px;
  box-shadow: 0 1.5px 1px 0 #e4e4e7;
}

.mine .wrapper .content .wallet .part-1 {
  display: flex;
  align-items: center;
  height: 100px;
}

.mine .wrapper .content .wallet .font-primary-color {
  color: #000;
}

.font-gray {
  color: #868686;
}

.mine .wrapper .content .wallet .part-2 {
  display: flex;
  align-items: center;
  height: 150px;
}

.mine .wrapper .content .wallet .part-2 .balance {
  flex: 1;
  font-size: 60px;
  color: #7e5678;
  font-weight: 700;
}

.mine .wrapper .content .wallet .van-hairline--bottom::after {
  border-bottom-width: 3px;
}

.mine .wrapper .content .wallet .part-2 .refresh-btn {
  margin-left: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  font-size: 30px;
  border-radius: 50%;
  color: #ffffff;
  background-color: #e6c3a1;
}

.user {
  overflow: auto
}

.user .box1 {
  background-color: #fff;
  box-shadow: 0 5px 10px rgba(0, 0, 0, .05);
  margin: 0 50px 30px;
  border-radius: .625rem
}

.user .userBalance {
  display: flex;
  color: #fff;
  font-size: 1.0625rem;
  margin: 0 1.25rem;
  padding: 50px 0 20px;
  border-bottom: 1px solid #dfe8f6;
  position: relative
}

.user .userBalance:after {
  content: " ";
  display: inline-block;
  height: .625rem;
  width: .625rem;
  border-width: 2px 2px 0 0;
  border-color: #292d32;
  border-style: solid;
  transform: matrix(.71, .71, -.71, .71, 0, 0);
  position: relative;
  top: -2px;
  position: absolute;
  top: 50%;
  margin-top: -4px;
  right: 5px
}

.user .userBalance > div {
  width: 50%;
  line-height: 1.15625rem;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: column;
  flex: 1;
  align-items: flex-start;
  color: #a2a2a2;
  font-family: PingFang SC;
  font-weight: medium;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0px;
  text-align: left
}

.user .userBalance > div .num {
  display: flex;
  color: #454545;
  font-family: semibold;
  font-weight: 700;
  font-size: 1.625rem;
  line-height: 1.875rem;
  letter-spacing: -1px;
  text-align: left;
  padding-top: .3125rem
}

.user .userBalance > div .sym {
  font-size: .875rem
}

.user .userBalance > div .eyeIcon {
  margin-left: .5rem;
  width: 1.25rem;
  height: 1.25rem
}

.user .userBalance > div .eyeIcon img {
  width: 1.25rem;
  height: 1.25rem
}

.user .btnView {
  display: flex;
  align-items: center;
  background: #fff;
  height: 2.875rem
}

.user .btnView div {
  width: 50%;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #222
}

.user .btnView div uni-image {
  width: 1.6875rem;
  height: 1.6875rem;
  margin-right: .3125rem
}

.user .cells2 {
  margin: 0 16PX;
  margin-top: .625rem;
  display: flex;
  align-items: center;
  font-size: 1.0625rem;
  overflow: hidden;
  position: relative;
  border-radius: 10px
}

.user .cells2 .item {
  display: flex;
  font-size: .875rem;
  padding: 1.25rem 0;
  color: #2a3563;
  width: 100%;
  position: relative;
  flex-direction: column;
  align-items: center
}

.user .cells2 .item img {
  margin-bottom: 10px;
  width: 1.5625rem;
  height: 1.5625rem
}

.user .cells {
  margin: 0 16PX;
  background-color: #fff;
  display: flex;
  align-items: center;
  overflow: hidden;
  position: relative;
  border-radius: 10px;
  box-shadow: 0 5px 10px rgba(0, 0, 0, .05)
}

.user .cells .item {
  display: flex;
  font-size: 28px;
  height: 100px;
  padding: .625rem 1.25rem;
  color: #9ba4af;
  width: 100%;
  position: relative;
  align-items: center
}

.user .cells .item img {
  width: 40px;
  height: 40px;
  margin-right: 1rem
}

.user .cells .item:before {
  content: " ";
  position: absolute;
  left: 0;
  top: 0;
  right: 1.25rem;
  height: 1px;
  border-top: 1px solid #dfe8f6;
  color: #dfe8f6;
  transform-origin: 0 0;
  transform: scaleY(.5);
  left: 1.25rem
}

.user .cells .item:after {
  content: " ";
  display: inline-block;
  height: 26px;
  width: 20px;
  border-width: 2px 2px 0 0;
  border-color: #848fac;
  border-style: solid;
  transform: matrix(.71, .71, -.71, .71, 0, 0);
  position: relative;
  top: -2px;
  position: absolute;
  top: 50%;
  margin-top: -4px;
  right: 1.375rem
}

.user .logout {
  margin: 1.4375rem 1.75rem 0;
  background: linear-gradient(99.09deg, #66BCFF 0%, #308EE3 100%);
  font-size: .75rem;
  border-radius: 8px
}

.user .logout .item {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: .75rem;
  height: 2.75rem;
  padding: .625rem .9375rem;
  color: #fff
}

.u-flex {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 32px;
}
.u-flex-col {
  display: flex;
  flex-direction: column;
}
.login-btn1{
  width: 100%;
  height: 100px;
  border-radius: 15px;
  color: #fff;
  background: linear-gradient(99.09deg, #66bcff 0%, #ec1d25 100%);
  font-size: 34px;
  font-weight: bolder;
  border: none;
}
/* 头部红色背景区域 */
.header-red-bg {
  background: linear-gradient(135deg, #f84c4c 0%, #d6000f 100%);
  padding: 20PX 20PX 20PX 20PX; /* 底部留出空间给下方的白色按钮卡片 */
  position: relative;
  overflow: hidden;
  border-radius: 5PX;
  margin:10PX 16PX;
}

/* 背景装饰圆圈 */
.header-red-bg::before {
  content: '';
  position: absolute;
  top: -30PX;
  right: -30PX;
  width: 150PX;
  height: 150PX;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
}

/* Logo区域 */
.logo-area {
  margin-bottom: 25PX;
}

.logo-area img {
  height: 32PX;
  margin-right: 8PX;
}

.logo-text {
  color: white;
  font-size: 22PX;
  font-weight: bold;
  letter-spacing: 1PX;
}

.logo-slogan {
  color: rgba(255, 255, 255, 0.8);
  font-size: 11PX;
  margin-top: 2PX;
  display: block;
}

/* 用户信息区域 */
.user-info {
  display: flex;
  align-items: center;
  margin-bottom: 20PX;
}

.avatar {
  width: 45PX;
  height: 45PX;
  background-color: #FFC107;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 20PX;
  font-weight: bold;
  margin-right: 15PX;
  border: 2PX solid rgba(255,255,255,0.5);
}
.avatar img{
  border-radius: 50%;
  width: 100%;
}

.user-name {
  color: white;
  font-size: 16PX;
  font-weight: 600;
  margin-bottom: 4PX;
}

.user-balance {
  color: white;
  font-size: 18PX;
  font-weight: bold;
}

/* 右侧快捷操作图标组 */
.quick-actions {
  position: absolute;
  right: 20PX;
  bottom: 50PX; /* 定位在头像右侧偏下 */
  display: flex;
  gap: 10PX;
}

.action-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: white;
  text-decoration: none;
}

.action-icon {
  width: 40PX;
  height: 40PX;
  border: 1PX solid rgba(255,255,255,0.5);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 6PX;
  font-size: 14PX;
}

.action-text {
  font-size: 11PX;
  opacity: 0.9;
}

/* 白色操作卡片（提现/充值） */
.action-card {
  display: flex;
}

.btn-action {
  background-color: #f6dddd;
  border: 1PX solid #eee;
  border-radius: 8PX;
  padding: 10PX;
  font-size: 14PX;
  color: #333;
  font-weight: 500;
  cursor: pointer;
  box-shadow: 0 2PX 5PX rgba(0,0,0,0.02);
  margin-right: 8PX;
}

.btn-action i {
  color: #d6000f;
  margin-right: 8PX;
  font-size: 16PX;
}

</style>
